<template>
    <div class="takeawayMobile">
        <div class="over-lay"></div>
        <div class="bodyContent">
            <div class="smallcontainer" v-if="takeawayObject">
                <div class="headsmall">
                    <img class="logosl" src="../assets/coloredlogotone.png" />
                    <a href="javascript:" @click="$router.push('/mytone')" ><img class="topbtn" src="../assets/TONE_HOME_ICON.png" /></a>
                    <img src="https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/0a3d90ee-c79e-472c-9bae-1a89539be47c.jpg" class="grad" />
                </div>
                <h1>Hey there, {{takeawayObject.firstName}}</h1>
                <p class="firstpara">Thanks for watching!The following TONE Takeaways will help you set the tone of your day.</p>
                <a class="lglink" href="javascript:" @click="$router.push(takeawayObject.video1UrlKey)">{{takeawayObject.video1Key}}</a>
                <div class="listesection" v-for="takeaway in takeawayObject.tonetakeAways">
                    <div class="row">
                        <div class="briefcasesection">
                            <img src="https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/01041c2a-2e73-4ca5-99b9-827c441be3e2.png" />
                        </div>
                        <div class="briefcasetext">
                            <h4>Tone Takeaways:</h4>
                            <a class="brieflink" href="javascript:" @click="$router.push(takeaway.videoURL)">{{takeaway.vTitle}}</a>
                        </div>
                    </div>
                    <div class="row listingsection" v-if="takeaway.tone1">
                        <div class="listentryholder">
                            <div class="listingimg">
                                <img src="https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/24ffbbd6-7718-487e-a23d-7f968c64428f.png" />
                            </div>
                            <div class="listingtext">
                                {{takeaway.tone1}}
                            </div>
                        </div>
                        <div class="listentryholder" v-if="takeaway.tone2">
                            <div class="listingimg">
                                <img src="https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/b0047950-fa37-44f7-9b0c-2ec540e2b6eb.png" />
                            </div>
                            <div class="listingtext">
                                {{takeaway.tone2}}
                            </div>
                        </div>
                        <div class="listentryholder" v-if="takeaway.tone3">
                            <div class="listingimg">
                                <img src="https://gallery.mailchimp.com/cde61e634f6de54ad41142732/images/c2bc65aa-8383-4e0f-a6dc-d25fd9828a74.png" />
                            </div>
                            <div class="listingtext">
                                {{takeaway.tone3}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="purpletextcontainer" v-if="takeawayObject.talkTitle || takeawayObject.expertName">
                    <hr />
                    <h3>Upcoming Events</h3>
                    <div class="entryholder" v-if="takeawayObject.talkTitle"> <img :src="takeawayObject.talkImgUrl" />
                        <h4>Tone Talk:{{takeawayObject.talkTitle}}</h4>
                        <p>
                            {{takeawayObject.talkLongDescription}}<br><br>{{takeawayObject.talkStartDate}}</p>
                        <a href="javascript:" @click="$router.push(`/event/${takeawayObject.talkEventId}`)">Add to Calendar</a></div>
                    <div class="entryholder" v-if="takeawayObject.expertName"> <img :src="takeawayObject.eventImgUrl" />
                        <h4>Tone Live: {{takeawayObject.expertName}}</h4>
                        <p>
                            {{takeawayObject.eventLongDescription}}<br><br>{{takeawayObject.eventStartDate}}</p>
                        <a href="javascript:" @click="$router.push(`/event/${takeawayObject.eventEventId}`)">Add to Calendar</a></div>
                </div>
                <a href="javascript:" @click="$router.push('/mytone')" ><img class="topbtn lastlogobutton" src="../assets/TONE_HOME_ICON.png" /></a>
                <br />
                <h3 class="pinktext">Set the tone of your life</h3>
                <p class="lastpara">- The TONE Team</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import { isMedianShell, shouldApplyMedianBottomTabBar, applyMedianNativeNavigationCommands } from '../helpers/medianNativeNavigation'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'takeawaymobile',
        data: function () {
            return {
                success: false,
                successMsg: '',
                takeawayObject: null,
                appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation'
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getOriginalVideoCode', 'getToneTakeaways'
            ])
        },
        methods: {
        },
        mounted: function () {
            let self = this
            if (self.user && isMedianShell()) {
                let info = {userId: self.user.userId}
                let jsonFile = ''
                if (self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                    jsonFile = 'sidebar_auth_corp.json'
                } else {
                    jsonFile = 'sidebar_auth.json'
                }
                const loadBottomTabs = shouldApplyMedianBottomTabBar()
                $.getJSON(`${self.appNavigationURL}/${jsonFile}`, function (sidebarData) {
                    console.log('side navigation (auth) returned', sidebarData)
                    if (loadBottomTabs) {
                        $.getJSON(`${self.appNavigationURL}/bottomNav_auth.json`, function (tabsData) {
                            console.log('bottom navigation (auth) returned', tabsData)
                            applyMedianNativeNavigationCommands({
                                registrationCustomData: info,
                                sidebarItems: sidebarData,
                                tabsPayload: tabsData
                            })
                        }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                    } else {
                        applyMedianNativeNavigationCommands({
                            registrationCustomData: info,
                            sidebarItems: sidebarData
                        })
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                // Get Takeaway data
                self.$store.dispatch('GETTONETAKEAWAY', self.user.userId).then(() => {
                    self.takeawayObject = self.getToneTakeaways
//                    console.log('takeaway object', this.takeawayObject)
                })
            } else {
                self.$router.push('/')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .smallcontainer {
        max-width: 500px;
        margin: auto;
        font-size: 18px;
    }

    p {
        font-size: 18px;
        font-weight: 500;
    }

    a.lglink {
        font-size: 20px;
        font-weight: 500;
        color: #000;
        text-decoration: underline;
        margin: 30px 0 20px;
        display: block;
        cursor: pointer;
    }

    .purpletextcontainer a {
        display: block;
        margin: 20px 0 40px;
    }

    .purpletextcontainer p {
        color: #8e628b;
        font-style: italic;
        font-size: 22px;
        font-weight: 900;
    }

    .purpletextcontainer hr {
        border-color: #f2617d;
    }
    h3 {
        color: #f0617d;
    }

    .purpletextcontainer h3 {
        font-weight: 900;
        color: #8e628b;
    }

    .entryholder {
        text-align: left;
    }

    .entryholder p {
        font-size: 16px;
        font-style: normal;
        font-weight: normal;
        color: #000;
    }

    .entryholder > a {
        text-align: center;
    }

    .graylastext {
        font-size: 16px;
    }
    img.video {
        max-width: 90%;
        margin: auto;
        display: block;
    }

    img {
        max-width: 100%;
    }

    .graylastext {
        margin: 50px 0 30px;
    }

    .bodyContent {
        padding-bottom: 50px;
    }

    img.blowhorn {
        max-width: 100%;
    }

    .entryholder {
        margin-top: 20px;
    }

    .entryholder p {
        margin: 0 0 40px;
    }

    .entryholder img {
        margin: 0 0 20px;
    }
    img.grad {
        max-width: 100%;
    }

    img.topbtn {
        float: right;
        padding: 10px;
        border: 1px solid #f0617d;
        border-radius: 10px;
    }

    img.logosl {
        float: left;
        margin-top: 10px;
    }

    .smallcontainer {
        padding-top: 50px;
        padding-left: 20px;
        padding-right: 20px;
    }
    img.topbtn.lastlogobutton {
        float: none !important;
    }


    p.firstpara {
        text-align: left;
    }

    .listesection {}

    .briefcasesection {
        float: left;
        padding: 0 15px;
        width: 26%;
    }

    .briefcasetext {
        float: left;
        width: 74%;
        padding: 0 15px;
        text-align: left;
    }

    .briefcasetext h4 {
        margin: 10px 0 0;
    }

    a.brieflink {
        font-size: 18px;
        color: #8e628b;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 500;
    }

    .listingimg {
        float: left;
        width: 20%;
        padding-left: 30px;
        clear: left;
        margin: 10px 0;
    }

    .listingtext {
        width: 80%;
        float: left;
        text-align: left;
        margin-top: 12px;
        font-style: italic;
        color: #000;
        font-weight: 500;
    }

    .listentryholder {
        margin-top: 10px;
    }
    .listesection {
        margin: 0 auto 40px;
        max-width: 90%;
    }
</style>



// WEBPACK FOOTER //
// TakeawayMobile.vue?370a943d